import React from "react";
import { Route, Routes } from "react-router-dom";
import { SimpleLayout } from "../components/simpleLayout";

// ROTAS
import SatisfacaoFormulariosLancamento from "../pages/pesquisaSatisfacao/formulariosLancamento";

const SatisfacaoRoutes = () => {
  return (
    <SimpleLayout>
      <Routes>
        <Route path="*" element={<SatisfacaoFormulariosLancamento />} />
      </Routes>
    </SimpleLayout>
  );
};

export { SatisfacaoRoutes };
